<app-nav-admin--menu></app-nav-admin--menu>
<div class="configContent">
<h1 class="configTitle">Settings</h1>
<p class="lead">
  Country >> Protection Type >> Filing Route >> Technical Field
</p>
<ng-template [ngIf]="dataSource.data.length === 0">Loading...</ng-template>

<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="edit-country-tree">
  <!-- This is the tree node template for leaf nodes -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
    <li class="mat-tree-node">
      <!-- use a disabled button to provide padding for tree leaf -->
      <button mat-icon-button disabled></button>
      <mat-checkbox class="mt-2 me-2" [checked]="node.checked" (change)="itemSelectionToggle(node)"></mat-checkbox>
      {{node.name}}
    </li>
  </mat-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
    <li>
      <div class="mat-tree-node">
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        <mat-checkbox class="mt-2 me-2" *ngIf="node.level > 0" [checked]="node.checked" (change)="itemSelectionToggle(node)"></mat-checkbox>
        {{node.name}}
      </div>
      <ul [class.enable-indent]="treeControl.isExpanded(node)" [class.edit-country-tree-invisible]="!treeControl.isExpanded(node)">
        <ng-container matTreeNodeOutlet></ng-container>
      </ul>
    </li>
  </mat-nested-tree-node>
</mat-tree>
<hr />

<div class="mb-5">
  <button mat-raised-button class="me-2" (click)="save()" [disabled]="!dirty">Save</button>
  <button mat-raised-button (click)="discard()" [disabled]="!dirty">Discard Changes</button>
</div>
  </div>
<footer>
  <patempoFooter></patempoFooter>
</footer>
